import React, { useState } from 'react';
import { AssociateDeviceTagPanel } from '../../Components/manage-tags/AssociateDeviceTagPanel';
import { TagKnown } from './TagsTable';
import { CreateTagPanel } from '../../Components/manage-tags/CreateTagPanel';
import { StyledModal } from '../../Components/StyledModal';

interface CreateTagModalProps {
  isVisible: boolean;
  onClose: () => void | Promise<void>;
  refetch: () => void;
}

export const CreateTagModal = ({
  isVisible,
  onClose,
  refetch,
}: CreateTagModalProps) => {
  const [selectedTag, setSelectedTag] = useState<TagKnown | null>(null);

  const updateSelectedTag = (tag: TagKnown) => {
    setSelectedTag(tag);
  };
  const handleClose = () => {
    setSelectedTag(null);
    refetch();
    onClose();
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={handleClose}
      label="create-tag-modal"
    >
      {!selectedTag ? (
        <CreateTagPanel
          onClose={handleClose}
          updateSelectedTag={updateSelectedTag}
        />
      ) : (
        <AssociateDeviceTagPanel onClose={handleClose} tag={selectedTag} />
      )}
    </StyledModal>
  );
};
